import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Modal } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import TextField from 'src/components/text-field';
import Button from 'src/components/button';
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md';
import DashboardLayout from 'src/containers/dashboard-layout';
import { AiOutlinePlus } from 'react-icons/ai';
import { BsCheckCircleFill } from 'react-icons/bs';
import Search from 'src/components/search';
import useFetch from 'src/hooks/useFetch';

interface IProps {}

type floorsPostValue = {
  name: string;
  price: any;
};

const categoryRepresentationPos = [
  {
    id: 0,
    color: '#EF476F',
  },
  {
    id: 1,
    color: '#ECAA00',
  },
  {
    id: 2,
    color: '#187855',
  },
  {
    id: 3,
    color: '#214E6D',
  },
  {
    id: 4,
    color: '#C2212D',
  },
  {
    id: 5,
    color: '#54478C',
  },
];

// form validation
const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Category name must a at least 3 character long')
    .required('Full is required'),
  price: Yup.number().required('Price is required'),
});

const AddModifiers: React.FC<IProps> = ({}) => {
  const { data: itemsData } = useFetch('/items');
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const [showSquareShape, setShowSquareShape] = React.useState(true);
  const [showCircleShape, setShowCircleShape] = React.useState(false);
  const [selectColor, setSelectColor] = React.useState('#EF476F');
  const [showModal, setShowModal] = React.useState(false);
  const [showAccordion, setShowAccordion] = React.useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = React.useState<any>([]);

  const [query, setQuery] = React.useState('');

  const intValues = {
    name: '',
    price: null,
  };
  const handleSubmit = async (val: floorsPostValue) => {
    try {
      await Service.post('/modifiers/create', val);
      toastAlert('success', `${val?.name} Combo successfully added`);
      setErrorMsgPost('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
    }
  };

  const handleModal = () => setShowModal(!showModal);
  const searchCategoryData = itemsData?.items?.filter(
    (item: { name: string }) => {
      if (query === '') {
        return item;
      } else if (item?.name?.toLowerCase().includes(query.toLowerCase())) {
        return item;
      }
    }
  );

  function handleCheckboxChange(event: any) {
    const itemId = event.target.value;
    if (event.target.checked) {
      setSelectedCheckboxes([...selectedCheckboxes, itemId]);
    } else {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((id: string) => id !== itemId)
      );
    }
  }

  const filterCheckBoxData = itemsData?.items
    ? itemsData?.items.filter((item: any) =>
        selectedCheckboxes.includes(item?.id)
      )
    : null;
  itemsData?.items
    ? itemsData?.items.map((val: any) => {
        if (val?.hasVariants) {
          const newCheckBoxData = val?.variants?.filter(
            (value: { id: string }) => selectedCheckboxes?.includes(value?.id)
          );

          filterCheckBoxData.push(newCheckBoxData);
        }
      })
    : null;

  return (
    <>
      {errorMsgPost && (
        <p className="text-warning text-center text-sm font-semibold capitalize">
          {errorMsgPost}
        </p>
      )}
      <Formik
        initialValues={intValues}
        validateOnMount
        validationSchema={FORM_VALIDATION}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, isValid, values }) => (
          <Form className="mt-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div className="">
                <TextField
                  label="Combo Name"
                  name="name"
                  placeholder="Enter a combo name"
                />
                <TextField
                  label="Price"
                  name="price"
                  placeholder="Enter a price"
                  type="text"
                />
                <div className="">
                  <h5 className="text-xl font-semibold mb-4">
                    Representation on POS
                  </h5>
                  <div className="flex items-center space-x-10 mb-10">
                    <div
                      onClick={() => {
                        setShowSquareShape(true);
                        setShowCircleShape(false);
                      }}
                      className={`${
                        showSquareShape
                          ? 'border-primary'
                          : 'border-border-color-dark'
                      }  h-16 w-16 border border-border-color-dark flex items-center justify-center cursor-pointer rounded`}
                    >
                      {showSquareShape && <BsCheckCircleFill color="#4062FF" />}
                    </div>
                    <div
                      onClick={() => {
                        setShowSquareShape(false);
                        setShowCircleShape(true);
                      }}
                      className={`${
                        showCircleShape
                          ? 'border-primary'
                          : 'border-border-color-dark'
                      }  h-16 w-16 border border-border-color-dark flex items-center justify-center cursor-pointer rounded-full`}
                    >
                      {showCircleShape && <BsCheckCircleFill color="#4062FF" />}
                    </div>
                  </div>
                  <div className="grid grid-cols-4 gap-5 py-10 bg-border-color px-12">
                    {categoryRepresentationPos?.map((item) => (
                      <div
                        className={`${
                          showCircleShape ? 'rounded-full' : 'rounded'
                        } ${
                          item?.color === selectColor &&
                          'border-primary border-2'
                        } h-[55px] w-[55px]  shadow-xl cursor-pointer hover:ease-in-out transform hover:scale-[10px] transition-all duration-700 mb-5`}
                        key={item?.id}
                        style={{ backgroundColor: `${item?.color}` }}
                        onClick={() => setSelectColor(item?.color)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="pt-5">
                <div
                  className="border rounded-lg cursor-pointer border-primary space-x-3 p-3 flex items-center justify-center"
                  onClick={handleModal}
                >
                  <AiOutlinePlus color="#4062FF" size={20} />
                  <p className="font-semibold text-primary">Add items</p>
                </div>

                {filterCheckBoxData?.map((item: any) => (
                  <div
                    className="border border-border-color-dark p-4 rounded-xl bg-pure-white"
                    key={item?.id}
                  >
                    <div className="flex items-center justify-between">
                      <h5 className="text-text-black"> {item?.name} </h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center justify-end mt-10">
              <Button
                text="add Combo"
                variant="primary"
                isSubmitting={isSubmitting}
                isValid={isValid}
                type="submit"
              />
            </div>
          </Form>
        )}
      </Formik>
      {showModal && (
        <Modal onClick={handleModal} title="Add items">
          <div className="">
            <Search
              placeholder="search modifiers ....."
              query={query}
              setQuery={setQuery}
            />
            <div className="h-96 overflow-y-auto overflow-x-hidden">
              <div className="">
                {searchCategoryData?.length > 0 ? (
                  searchCategoryData?.map((items: any) => (
                    <div
                      className="py-2 mx-4 mt-3 border-b border-border-color-dark last:border-0"
                      key={items?.id}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          {!items?.hasVariants && (
                            <input
                              type="checkbox"
                              id={items?.id}
                              onChange={handleCheckboxChange}
                              value={items?.id}
                              checked={selectedCheckboxes.includes(items.id)}
                            />
                          )}
                          {items?.shape === null ||
                          (items?.shape === undefined &&
                            items?.color === null) ? (
                            <img
                              src={items?.image}
                              alt="item-image"
                              className="w-12 h-12 object-cover rounded-xl"
                            />
                          ) : (
                            <div
                              className={`w-8 h-8 ${
                                items?.shape === 'circle'
                                  ? 'rounded-full'
                                  : 'rounded'
                              }`}
                              style={{ backgroundColor: items?.color }}
                            />
                          )}
                          <h6 className="font-semibold capitalize">
                            {items?.name}
                          </h6>
                        </div>
                        {items?.hasVariants && (
                          <div
                            onClick={() => setShowAccordion(!showAccordion)}
                            className="h-5 w-5 rounded-full cursor-pointer bg-pure-white shadow-lg flex items-center justify-center"
                          >
                            {showAccordion ? (
                              <MdOutlineKeyboardArrowUp
                                color="#4062FF"
                                size={25}
                              />
                            ) : (
                              <MdOutlineKeyboardArrowDown
                                color="#4062FF"
                                size={25}
                              />
                            )}
                          </div>
                        )}
                      </div>
                      {items?.hasVariants &&
                        items?.variants?.map((item: any) => (
                          <div className="" key={item?.id}>
                            {showAccordion && (
                              <div className="flex items-center space-x-3">
                                <input
                                  type="checkbox"
                                  id={item?.id}
                                  onChange={handleCheckboxChange}
                                  value={item?.id}
                                  checked={selectedCheckboxes.includes(item.id)}
                                />

                                <h2> {item?.name} </h2>
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  ))
                ) : (
                  <h5 className="text-warning mt-10 text-center font-semibold">
                    No items find
                  </h5>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-end mt-5">
            <Button text="add item" variant="primary" type="button" />
          </div>
        </Modal>
      )}
    </>
  );
};

export default React.memo(AddModifiers);
